import { render, staticRenderFns } from "./StudentMarksPage.vue?vue&type=template&id=29b90c00&scoped=true&"
import script from "./StudentMarksPage.vue?vue&type=script&lang=js&"
export * from "./StudentMarksPage.vue?vue&type=script&lang=js&"
import style0 from "./StudentMarksPage.vue?vue&type=style&index=0&id=29b90c00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b90c00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
